export default function useDocumentProperty(propertyId: string) {
    return {
        get: () => window.getComputedStyle(document.body).getPropertyValue(propertyId),
        set: (propertyValue: string | number | boolean) =>
            document.documentElement.style.setProperty(propertyId, `${propertyValue}`),
    };
}
